// Mixins
import { dateMixins } from "@/app/mixins/utils/date-mixins";

// Third Party libraries
import DatePicker from "vue2-datepicker";

export default {
    name: "InputWeightProgressionTable",
    components: { DatePicker },
    directive: {},
    filters: {},
    mixins: [dateMixins],
    props: {
        dateOfBirth: {
            type: Date,
            required: true,
            default: null,
        },
        notBeforeThisDate: {
            type: Date,
            required: true,
        },
        notAfterThisDate: {
            type: Date,
            required: true,
        },
        periodTitle: {
            type: String,
            required: false,
            default: "",
        },
        periodIndex: {
            type: Number,
            required: true,
            default: 0,
        },
        weightTrackerList: {
            type: Array,
            default() {
                return [];
            },
        },
        weightTrackerListToDelete: {
            type: Array,
            default() {
                return [];
            },
        },
        progressionPercentage: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    data() {
        const initialChartDataLabels = ["Birth Weight"];

        return {
            isLastEntryEmpty: false,
            initialChartDataLabels,
        };
    },
    computed: {
        maxNumEntries() {
            // 7 - Days in a week
            // 31 - Days in a month
            return this.periodTitle && this.periodTitle.toLowerCase().includes("week") ? 7 : 31;
        },
    },
    created() {},
    methods: {
        validatePuppyWeight(event, index) {
            const field = event.target;

            setTimeout(() => {
                // Use the regex to match the pattern: digits followed by an optional decimal point and more digits
                const regex = /^\d*\.?\d*/;

                // Check if the field has a valid value (exists and is not null/undefined)
                if (field && field.value) {
                    // Execute the regex and check if a match was found
                    const match = regex.exec(field.value);

                    // If the match is found, use the first match; otherwise, set the value to an empty string
                    let sanitizedInput = match ? match[0] : "";

                    // Apply the sanitized input to the field
                    event.target.value = sanitizedInput;
                }
            }, 0);
        },
        formatNumberField(event, index) {
            const field = event.target;

            setTimeout(() => {
                // Check if the field has a valid value (exists and is not null/undefined)
                if (field && field.value) {
                    const number = parseFloat(field.value).toFixed(2);
                    let sanitizedInput = null;
                    if (field < 0) {
                        sanitizedInput = 0;
                    } else {
                        sanitizedInput = isNaN(number) ? parseFloat("0").toFixed(2) : number;
                    }

                    // // Apply the sanitized input to the field
                    event.target.value = sanitizedInput;

                    // Set the sanitized value back to the model
                    this.weightTrackerList[index].weight = sanitizedInput;
                }
            }, 0);
        },
        disabledDatesChecker(date) {
            // for progression period, only disable the past dates
            if (this.periodTitle && this.periodTitle.toLowerCase() === "progression") {
                return date < this.notBeforeThisDate;
            }

            // disable past and present dates, depending on the period (week)
            return date < this.notBeforeThisDate || date >= this.notAfterThisDate;
        },
        getParsedValue(num) {
            if (isNaN(num)) {
                return 0;
            }

            return parseFloat(num);
        },
        getProgressionPercentage(num) {
            if (isNaN(num)) {
                return "";
            }

            // to handle empty current values/entries
            if (num === 0) {
                return "";
            }

            // this will happen if the current and previous values are same
            if (num === "0.00") {
                return "0.00%";
            }

            return Math.abs(num).toFixed(2) + "%";
        },
        createNewEntry() {
            return {
                id: "",
                key: Math.random().toString(),
                litterId: "",
                status: "ACTIVE",
                weight: "",
                unitsOfWeight: "KG",
                entry: "",
            };
        },
        onAddMoreWeightEntry() {
            const lastRowEntry = this.weightTrackerList.length ? this.weightTrackerList[this.weightTrackerList.length - 1] : null;

            // show validation error message requiring the last entry to have a selected date
            if (lastRowEntry && !lastRowEntry.entry) {
                this.isLastEntryEmpty = true;
                return;
            }

            const newWeightEntry = this.createNewEntry();
            this.weightTrackerList.push(newWeightEntry);
        },
        onChangeWeightInput(value, index) {
            if (!value) {
                return;
            }

            if (this.weightTrackerList[index]) {
                this.weightTrackerList[index].isError = false;
            }

            if (index === this.weightTrackerList.length - 1) {
                this.isLastEntryEmpty = false;
            }
        },
        async onDeleteWeightEntry(weightObj, index) {
            if (!weightObj) return;

            const confirmDeleteResult = await this.$swal({
                title: "Delete Weight Entry",
                text: "Are you sure you want to delete the entry?",
                showCancelButton: true,
                confirmButtonColor: "#4B8BFF",
                cancelButtonColor: "#d33",
                confirmButtonText: "Confirm",
                cancelButtonText: "Cancel",
                reverseButtons: true,
                showCloseButton: true,
            });

            if (confirmDeleteResult.isConfirmed) {
                if (weightObj.id && weightObj.status === "ACTIVE") {
                    this.weightTrackerListToDelete.push(weightObj.id);
                }

                this.weightTrackerList.splice(index, 1);
            }
        },
    },
    // third party libraries
};
